/**
 * baglantiYenidenDene — tarayıcıdan API'ye GET isteği bağlantı hatasında bir kez daha denenir (hq 22 Eki).
 *
 * Neden: 22 Eki 13:33:37–13:34:39 UTC TR kutusunun bağlantısı ~60 sn düştü; SSR ssrFetch ile korunuyordu, tarayıcıdaki
 * çağrılar korumasızdı. Yalnız idempotent GET: yazan / e-posta gönderen çağrı (POST/PUT/PATCH/DELETE) iki kez gitmemeli —
 * ilk istek sunucuya ulaşıp yanıtı yolda kaybolmuş olabilir.
 *
 * Yalnız ERR_NETWORK (yanıt hiç gelmedi). Zaman aşımı (ECONNABORTED; axiosInstance 10 dk), iptal (ERR_CANCELED) ve
 * HTTP hataları denenmez. Adapter düzeyinde çalışır: interceptor'lar (token, 401, ErrorLog) bir kez koşar, ErrorLog'a
 * yalnız ikinci deneme de düşerse yazılır.
 */
import axios, { AxiosError, type AxiosAdapter, type InternalAxiosRequestConfig } from 'axios';

export const YENIDEN_DENEME_BEKLEME_MS = 1000;

export function yenidenDenenir(err: unknown, config: InternalAxiosRequestConfig): boolean {
  return (
    err instanceof AxiosError &&
    err.code === AxiosError.ERR_NETWORK &&
    !err.response &&
    (config.method || 'get').toLowerCase() === 'get' &&
    !config.signal?.aborted
  );
}

export function yenidenDeneyenAdapter(asil: AxiosAdapter, beklemeMs = YENIDEN_DENEME_BEKLEME_MS): AxiosAdapter {
  return async (config) => {
    try {
      return await asil(config);
    } catch (err) {
      if (!yenidenDenenir(err, config)) throw err;
      await new Promise((r) => setTimeout(r, beklemeMs));
      return asil(config);
    }
  };
}

/** axios örneğine (ya da global axios'a) kurar; adapter her istekte o örneğin listesinden çözülür (axios dispatchRequest gibi). */
export function baglantiYenidenDeneKur(ornek: { defaults: { adapter?: Parameters<typeof axios.getAdapter>[0] | AxiosAdapter } }): void {
  const liste = ornek.defaults.adapter as Parameters<typeof axios.getAdapter>[0];
  ornek.defaults.adapter = yenidenDeneyenAdapter((config) => axios.getAdapter(liste)(config));
}
